import { Component, OnInit } from '@angular/core';
import { RottweilerDogsAnimalmanagementComponent } from '..//animalmodule/rottweiler-dogs-animalmanagement/rottweiler-dogs-animalmanagement.component';
import { StockmanagementComponent } from '..//stockmanagement/stockmanagement.component';
import { Router } from '@angular/router';
import { CommonService } from '../common.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
declare let swal: any;
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { allowedNodeEnvironmentFlags } from 'process';
declare var $: any;
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
@Component({
  providers: [RottweilerDogsAnimalmanagementComponent, StockmanagementComponent],
  selector: 'app-animalmanagementmodule',
  templateUrl: './animalmanagementmodule.component.html',
  styleUrls: ['./animalmanagementmodule.component.css']
})
export class AnimalmanagementmoduleComponent implements OnInit {
  rottwilerpageurl = "/dashboard/RottweilerDogsAnimalmanagement";
  addstock = "/dashboard/addstockmanagement";
  samepageroute = "/dashboard/animalmanagement";
  getlistApi: any;
  selectallvalue: any;
  getfarmsListData: any;
  loadspeciesValue: any;
  getbreedvalue: any;
  hido: boolean = false;
  addUrl: any;
  speciesloaddata: any;
  AnimalListID: any;
  dynamicfarmid: any;
  uploadedFiles:any = {
    Vaccine: null,
    Disease: null,
    Samples: null,
    Diagnostic: null,
    Deworming: null,
    Death: null
  };
  getStockListData: any;
  loginresponse: any;
  userrole: any;
  breedid: any;
  farm_userrole: any;
  agegroupchategoryval: any = [];
  farmuserlistanimalid: any = [];
  getlistApifarm: any;
  selectedValue3: any;
  disablebutton3: boolean = false;
  userrolact: any;
  isDisabled: boolean = false;
  selectedValue: string = '';
  isLoading = false;
  getspeciesid: any;
  speciesanimalcodelist: any = []
  loadagegroupvalue: any = []
  getgenerallistdata: any = [];
  getdeathlistdata: any = [];
  getvaccinelistdatatable: any = [];
  getdiseaselistdatatable: any = [];
  samplelistdatatable: any = [];
  ageid: any;
  selectedValue1: any;
  getdeworminglistdatatable: any = [];
  diagnosticlistdatatable: any = [];
  disablebutton1: boolean = false;
  isDisabledview: boolean = false;
  constructor(private router: Router, private commonService: CommonService, private formBuilder: FormBuilder, private comp: RottweilerDogsAnimalmanagementComponent, private stock: StockmanagementComponent) { }

  async ngOnInit() {

    this.disablebutton1 = true;
    this.disablebutton3 = true;
    //animal module table list data start...........
    this.getlistApi = "/stock_management";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      res => {
        this.getgenerallistdata = res.data;
      })
    this.getlistApi = "/animal_management/death/list";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      res => {
        this.getdeathlistdata = res.data;
      })
    this.getlistApi = "/animal_management/vaccine/list";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      res => {
        this.getvaccinelistdatatable = res.data;
      })
    this.getlistApi = "/animal_management/disease/list";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      res => {
        this.getdiseaselistdatatable = res.data;
      })
    this.getlistApi = "/animal_management/deworming/list";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      res => {
        this.getdeworminglistdatatable = res.data;
      })
    this.getlistApi = "/animal_management/diagnostics/list";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      res => {
        this.diagnosticlistdatatable = res.data;
      })
    this.getlistApi = "/animal_management/sample/list";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      res => {
        this.samplelistdatatable = res.data;
      })

    //animal module table list data end 

    var table;
    this.loginresponse = JSON.parse(sessionStorage.getItem('userrole'));
    this.userrole = this.loginresponse.read_status;
    this.userrolact = this.loginresponse.user_role
    this.farm_userrole = this.loginresponse.user_farm_id;
    if (this.userrole == 1) {
      this.isDisabled = true;
      // $(".edit").removeAttr("id"); // Element(s) are now enabled.
    }
    if (this.userrole == 0) {
      this.isDisabled = false;
      // $(".edit").removeAttr("id"); // Element(s) are now enabled.
    }
    if (this.farm_userrole) {
      this.isDisabledview = true;
      $("#farmname").attr("disabled", "disabled");

    }

    //this.view_table()
    $('.selectpicker').selectpicker('refresh');
    this.getlistApi = "/farms";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      async (res) => {

        table = $("#myTable").DataTable();

        this.getfarmsListData = res.data;
        setTimeout(function () {
          $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
        }, 1500);
        //farm user role based on view 
        if (this.farm_userrole) {
          this.isLoading = true;
          setTimeout(() => {
            var optionVal = this.farm_userrole;
            console.log(this.farm_userrole);
            $("#farmname").find("option[value=" + optionVal + "]").prop("selected", "selected");
          }, 500);
          setTimeout(() => {
            $('.selectpicker').selectpicker('refresh');
          }, 1000);
          this.loadspeciesValue = {
            "farms_id": this.farm_userrole
          }
          this.addUrl = "/species/farms";
          (await this.commonService.postApi(this.addUrl, this.loadspeciesValue)).subscribe(
            res => {
              this.speciesloaddata = res.data;
              console.log(this.speciesloaddata)
              setTimeout(function () {
                $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
              }, 1500);
            })
          //   this.addUrl = "/species/farms";
          this.getlistApi = "/stock_management/all_data/filters/?farm_id=" + this.farm_userrole + "&species_id=" + null + "&age=" + null + "&breed_id=" + null + "";
          (await this.commonService.getApi(this.getlistApi)).subscribe(
            res => {
              this.getStockListData = res.data;
              setTimeout((res) => {
                this.isLoading = false;
                table = $("#myTable").DataTable();
                $('.selectpicker').selectpicker('refresh')
              }, 1000);

            })
          $('#speciessearch').on('keyup', function () {
            var inputValue = (<HTMLInputElement>document.getElementById('speciessearch')).value;
            table.search(inputValue).draw();
          });
        }

      })
    $('#speciessearch').on('keyup', function () {
      var inputValue = (<HTMLInputElement>document.getElementById('speciessearch')).value;
      table.search(inputValue).draw();
    });
    //farm user role based on view end
    setTimeout(function () {
      $('#reportrange_date').daterangepicker('refresh');
      $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
    }, 1500);
    $('#farmname').change(async () => {
      $("#speciesid").find('option').remove().end();
      console.log($('#farmname').val())
      this.selectallvalue = $('#farmname').val();
      var farmvalue = "";
      farmvalue = this.selectallvalue.toString();
      this.loadspeciesValue = {
        "farms_id": farmvalue
      };
      console.log(this.loadspeciesValue.farm_id)
      //species load in select dropdown based on farm select api call
      this.addUrl = "/species/farms";
      (await this.commonService.postApi(this.addUrl, this.loadspeciesValue)).subscribe(
        res => {
          console.log(this.speciesloaddata)
          setTimeout((res) => {
            this.isLoading = false;
            table = $("#myTable").DataTable();
          }, 500);


          this.speciesloaddata = res.data;
          setTimeout(function () {
            $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
          }, 1500);
        })
      $('#speciessearch').on('keyup', function () {
        var inputValue = (<HTMLInputElement>document.getElementById('speciessearch')).value;
        table.search(inputValue).draw();
      });
    });
    $(document).on('change', '#farmname', function () {
      $('.myFakeClass').dropdown('toggle');
    });
    $(document).on('change', '#Speciesname', function () {
      $('.myFakeClass1').dropdown('toggle');
    });
    $(document).on('change', '#BreedName', function () {
      $('.myFakeClass2').dropdown('toggle');
    });
    $(document).on('change', '#agetype', function () {
      $('.myFakeClass3').dropdown('toggle');
    });
    $(document).on('change', '#export', function () {
      $('.myFakeClass4').dropdown('toggle');
    });
    $(document).on('change', '#Upload', function () {
      $('.myFakeClass5').dropdown('toggle');
    });
  }
  async view_table() {
    this.isLoading = true;
    var table;
    this.getStockListData = [];
    $('#myTable').dataTable().fnDestroy();
    console.log(this.userrolact);
    if (this.userrolact == 'Admin' || this.userrolact == 'University Officer' || this.userrolact == 'Guest user' || this.userrolact == 'Director' || this.userrolact == 'Student/Research scholars') {
      this.getlistApi = "/stock_management";
      (await this.commonService.getApi(this.getlistApi)).subscribe(
        res => {
          this.getStockListData = res.data;
          setTimeout((res) => {
            this.isLoading = false;
            table = $("#myTable").DataTable();
          }, 3000);
        })
      $('#speciessearch').on('keyup', function () {
        var inputValue = (<HTMLInputElement>document.getElementById('speciessearch')).value;
        table.search(inputValue).draw();
      });
    }
    /* if(this.farm_userrole){
  
     this.getlistApifarm= "/stock_management/animal_code/farms/?farm_user="+this.farm_userrole;
     (await this.commonService.getApi(this.getlistApifarm)).subscribe(
       res => {
         setTimeout((res)=>{ 
           this.isLoading =false;
       }, 500);
           $(function(){
           table = $("#myTable").DataTable();
           })
           this.farmuserlistanimalid = res.data;                       
          })  
               
     }*/
  }
  //search filter dynamic data load start
  async getfarmvalue(e) {
    $("#tablehide").addClass("hidetable");
    $('#Speciesname option:not(:first)').remove();
    $('#Speciesname').find('option:eq(0)').prop('selected', true);
    $('#BreedName option:not(:first)').remove();
    $('#BreedName').find('option:eq(0)').prop('selected', true);
    $('#agetype option:not(:first)').remove();
    $('#agetype').find('option:eq(0)').prop('selected', true);
    this.getStockListData = [];
    this.isLoading = true;
    console.log(e.target.value)
    $('#myTable').dataTable().fnDestroy();
    this.dynamicfarmid = e.target.value
    var table;
    if (this.farm_userrole) {
      this.getlistApi = "/stock_management/all_data/filters/?farm_id=" + this.farm_userrole + "&species_id=" + null + "&age=" + null + "&breed_id=" + null + ""
    } else {
      this.getlistApi = "/stock_management/all_data/filters/?farm_id=" + this.dynamicfarmid + "&species_id=" + null + "&age=" + null + "&breed_id=" + null + ""
    }

    (await this.commonService.getApi(this.getlistApi)).subscribe(
      res => {

        this.getStockListData = res.data;
        $("#tablehide").addClass("hidetable");
        setTimeout(() => {

          table = $("#myTable").DataTable();
          this.isLoading = false;
          $('.selectpicker').selectpicker('refresh')
        }, 1000);
      })
    $('#speciessearch').on('keyup', function () {
      var inputValue = (<HTMLInputElement>document.getElementById('speciessearch')).value;
      table.search(inputValue).draw();
    });

  }
  async breedselectbyspecies(event) {
    $("#tablehide").addClass("hidetable");
    var table;
    this.getStockListData = [];
    this.isLoading = true;
    $('#myTable').dataTable().fnDestroy();
    this.getspeciesid = event.target.value;
    this.addUrl = "/breeds/species/" + this.getspeciesid;
    (await this.commonService.getApi(this.addUrl)).subscribe(
      res => {
        this.getbreedvalue = res.data;
        console.log(this.getbreedvalue);
      });

    this.addUrl = "/species/age_group/all_category/?species_id=" + this.getspeciesid;
    (await this.commonService.getApi(this.addUrl)).subscribe(
      res => {
        this.loadagegroupvalue = res.data;
      });
    if (this.farm_userrole) {
      this.addUrl = "/stock_management/all_data/filters/?farm_id=" + this.farm_userrole + "&species_id=" + this.getspeciesid + "&age=" + null + "&breed_id=" + null + ""
    } else {
      this.addUrl = "/stock_management/all_data/filters/?farm_id=" + this.dynamicfarmid + "&species_id=" + this.getspeciesid + "&age=" + null + "&breed_id=" + null + ""
    }
    (await this.commonService.getApi(this.addUrl)).subscribe(
      res => {
        this.getStockListData = res.data;
        $("#tablehide").addClass("hidetable");
        setTimeout(() => {
          this.isLoading = false;

          table = $("#myTable").DataTable();

        }, 1000);


        setTimeout(function () {
          $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
        }, 1500);
      })
    $('#speciessearch').on('keyup', function () {
      var inputValue = (<HTMLInputElement>document.getElementById('speciessearch')).value;
      table.search(inputValue).draw();
    });
  }
  showtabledataa() {
    $("#tablehide").removeClass("hidetable");
  }

  async loadanimaldata(e) {
    $("#tablehide").addClass("hidetable");
    var table;
    this.isLoading = true;
    this.getStockListData = [];
    $('#myTable').dataTable().fnDestroy();
    this.breedid = e.target.value;
    if (this.farm_userrole) {
      this.getlistApi = "/stock_management/all_data/filters/?farm_id=" + this.farm_userrole + "&species_id=" + this.getspeciesid + "&age=" + null + "&breed_id=" + this.breedid + ""
    } else {
      this.getlistApi = "/stock_management/all_data/filters/?farm_id=" + this.dynamicfarmid + "&species_id=" + this.getspeciesid + "&age=" + null + "&breed_id=" + this.breedid + ""
    }
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      res => {
        $("#tablehide").addClass("hidetable");
        this.getStockListData = res.data;
        setTimeout(() => {
          this.isLoading = false;
          table = $("#myTable").DataTable();
        }, 1000);

      })
    $('#speciessearch').on('keyup', function () {
      var inputValue = (<HTMLInputElement>document.getElementById('speciessearch')).value;
      table.search(inputValue).draw();
    });
  }
  async selectagegroup(e) {
    $("#tablehide").addClass("hidetable");
    this.isLoading = true;
    this.getStockListData = [];
    $('#myTable').dataTable().fnDestroy();
    this.ageid = e.target.value
    var table;
    if (this.breedid == undefined) {
      var breedid = null;
    } else {
      var breedid = this.breedid;
    }
    if (this.farm_userrole) {
      this.getlistApi = "/stock_management/all_data/filters/?farm_id=" + this.farm_userrole + "&species_id=" + this.getspeciesid + "&age=" + this.ageid + "&breed_id=" + breedid + ""
    } else {
      this.getlistApi = "/stock_management/all_data/filters/?farm_id=" + this.dynamicfarmid + "&species_id=" + this.getspeciesid + "&age=" + this.ageid + "&breed_id=" + breedid + ""
    }
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      res => {
        $("#tablehide").addClass("hidetable");
        this.getStockListData = res.data;
        console.log(this.AnimalListID)
        setTimeout(() => {
          this.isLoading = false;
          table = $("#myTable").DataTable();
        }, 1000);

      })
    $('#speciessearch').on('keyup', function () {
      var inputValue = (<HTMLInputElement>document.getElementById('speciessearch')).value;
      table.search(inputValue).draw();
    });
  }
  animalcode(e) {
    console.log(e.target.id)
    var idval = e.target.id.split('_');
    var animalid = idval[0];
    var farmid = idval[1];
    var speciesid = idval[2];
    var breedid = idval[3];
    var ageid = idval[4]
    sessionStorage.setItem('animalid', animalid);
    sessionStorage.setItem('farmid', farmid);
    sessionStorage.setItem('speciesid', speciesid);
    sessionStorage.setItem('breedid', breedid);
    sessionStorage.setItem('ageid', ageid);
    this.router.navigate([this.rottwilerpageurl]);
  }

  stockmanagementapi() {
    this.disablebutton1 = false;
    this.comp.stockmanagement()
  }
  importbulkdata(element) {
    console.log(element);
    const file = element.target.files[0];
    if (file) {
      this.uploadedFiles[element.target.id] = file;
    }
    var value1 = element.target.id;
    switch (value1) {
      case "General":
        this.comp.importbulkdatafromexcelforgeneral(element)
        break;
      case "Vaccine":
        this.comp.importbulkdatafromexcelforvaccine(element)
        break;
      case "Disease":
        this.comp.importbulkdatafromexcelfordisease(element)
        break;
      case "Samples":
        var cmmnupload = "Samples";
        this.comp.importbulkdatafromexcel(element, cmmnupload)
        break;
      case "Diagnostic":
        var cmmnupload = "Diagnostic";
        this.comp.importbulkdatafromexcel(element, cmmnupload)
        break;

      case "Deworming":
        this.comp.importbulkdatafromexcelforDeworming(element)
        //  this.comp.exportDewormingdata();
        break;
      case "Death":
        var cmmnupload = "Death";
        this.comp.importbulkdatafromexcel(element, cmmnupload)
        // this.comp.exportDeath();
        break;
    }
  }

  //export data start
  Exportdata(element) {
    this.disablebutton3 = false;
    var value1 = element.target.value;
    console.log(value1);
    this.selectedValue3 = value1
    /*switch(value1){
         case "General":
           this.exportGeneral();
             break;
         case "Vaccine":
             this.exportvaccinedata();
             break;
         case "Disease":
           this.exportdiseasedata();
           break;
         case "Samples":
           this.exportsamplesdata();
             break;
         case "Diagnostic":
           this.exportDiagnosticdata();
             break;
           case "Deworming":
             this.exportDewormingdata();
             break;
         case "Death":
           this.exportDeath();
             break;
     }*/
  }

  exportvaccinedata() {
    var downloadtabledata = this.getvaccinelistdatatable;
    console.log(downloadtabledata);
    var resultarry = downloadtabledata.map((ele) => {
      if (ele.tnam_vac_date_of_first_vaccine != null) {
        var vaccinedate1 = ele.tnam_vac_date_of_first_vaccine.split('T');
        var getvaccinedate1 = vaccinedate1[0];
      }
      if (ele.tnam_vac_date_of_second_vaccine != null) {
        var vaccinedate2 = ele.tnam_vac_date_of_second_vaccine.split('T');
        var getvaccinedate2 = vaccinedate2[0];
      }
      if (ele.tnam_vac_expiry_date != null) {
        var expirydate = ele.tnam_vac_expiry_date.split('T');
        var getexpirydate = expirydate[0];
      }
      return { "Animal id": ele.tnam_vac_animal_code, "Vaccine name": ele.tnam_vac_vaccine_name, "Batch no": ele.tnam_vac_batch_number, "expiry date": getexpirydate, "dose Value": ele.tnam_vac_dose_value, "units": ele.tnam_vac_units, "Vaccine date1": getvaccinedate1, "Vaccine date2": getvaccinedate2 }
    })

    this.exportAsExcelFile(resultarry, 'vaccine');
  }

  exportdiseasedata() {
    var downloadtabledata = this.getdiseaselistdatatable;
    var resultarry = downloadtabledata.map((ele) => {
      var discoverydate = ele.tnam_dis_date_of_discovery.split('T');
      return { "Animal id": ele.tnam_dis_animal_code, "Disease name": ele.tnam_dis_disease_name, "Drug name": ele.tnam_dis_drug_name, "dose value": ele.tnam_dis_dose_value, "unit": ele.tnam_dis_units, "Date Of Discovery": discoverydate[0], "Treatment given": ele.tnam_dis_treatment_given, "discription": ele.tnam_dis_disease_description }
    })
    console.log(resultarry);
    this.exportAsExcelFile(resultarry, 'disease');
  }
  exportsamplesdata() {
    var downloadtabledata = this.samplelistdatatable;
    var resultarry = downloadtabledata.map((ele) => {
      if (ele.tnam_sam_date_of_sample_collected != null) {
        var sampledate = ele.tnam_sam_date_of_sample_collected.split('T');
        var getsampledate = sampledate[0];
      }
      return { "Animal id": ele.tnam_sam_animal_code, "Sample date": getsampledate, "Sample collected": ele.tnam_sam_sample_collected, "description": ele.tnam_sam_description }
    })
    console.log(resultarry);
    this.exportAsExcelFile(resultarry, 'samples');
  }
  exportDiagnosticdata() {
    var downloadtabledata = this.diagnosticlistdatatable;
    var resultarry = downloadtabledata.map((ele) => {
      if (ele.tnam_dgn_date_of_test != null) {
        var Dateoftest = ele.tnam_dgn_date_of_test.split('T');
        var getDateoftest = Dateoftest[0];
      }

      return { "Animal id": ele.tnam_dgn_animal_code, "Diagnostic test name": ele.tnam_dgn_diagnostics_test_name, "date Of test": getDateoftest, "test description": ele.tnam_dgn_diagnostics_description }
    })
    console.log(resultarry);
    this.exportAsExcelFile(resultarry, 'Diagnostic');
  }
  exportDewormingdata() {
    var downloadtabledata = this.getdeworminglistdatatable;
    var resultarry = downloadtabledata.map((ele) => {
      if (ele.tnam_dew_deworming_date != null) {
        var DewormingDate = ele.tnam_dew_deworming_date.split('T');
        var getDewormingDate = DewormingDate[0];
      }
      if (ele.tnam_dew_expiry_date != null) {

        var expiryDate = ele.tnam_dew_expiry_date.split('T')
        var getexpiryDate = expiryDate[0];
      }

      return { "Animal id": ele.tnam_dew_animal_code, "Deworming date": getDewormingDate, "Deworming name": ele.tnam_dew_deworming_name, "batch no": ele.tnam_dew_batch_number, "expiry date": getexpiryDate, "description": ele.tnam_dew_deworming_description }
    })
    console.log(resultarry);
    this.exportAsExcelFile(resultarry, 'Deworming');
  }
  exportDeath() {
    var downloadtabledata = this.getdeathlistdata;
    var resultarry = downloadtabledata.map((ele) => {
      if (ele.tnam_dth_date_of_death != null) {

        var deathdate = ele.tnam_dth_date_of_death.split('T');
        var getdeathdate = deathdate[0];
      }

      return { "Animal id": ele.tnam_dth_animal_code, "Date Of death": getdeathdate, "cause Of death": ele.tnam_dth_cause_of_death }
    })
    console.log(resultarry);
    this.exportAsExcelFile(resultarry, 'Death');
  }
  exportGeneral() {
    var downloadtabledata = this.getgenerallistdata;
    var resultarry = downloadtabledata.map((ele) => {
      var birthdate = ele.tnsm_date_of_birth.split('T');
      if (ele.tnsm_date_of_transfer != null) {
        var transferdate = ele.tnsm_date_of_transfer.split('T');
        var gettransferdate = transferdate[0];
      }
      if (ele.tnsm_date_of_purchase != null) {
        var purchasedate = ele.tnsm_date_of_purchase.split('T');
        var getpurchasedate = purchasedate[0];
      }
      if (ele.tnsm_date_of_deletion != null) {
        var deletiondate = ele.tnsm_date_of_deletion.split('T');
        var getdeletiondate = deletiondate[0];
      }
      if (ele.tnsm_status == 1) {
        var statusc = "Active";
      } else {
        var statusc = "Inactive";
      }
      return { "Farm name": ele.farm_name, "Species name": ele.species_name, "Breed name": ele.breed_name, "DOB": birthdate[0], "age group": ele.tnsm_age, "Animal id": ele.tnsm_animal_code, "gender": ele.tnsm_sex, "weight": ele.tnsm_weight, "DOT": gettransferdate, "DOP": getpurchasedate, "DOD": getdeletiondate, "Status": statusc }
    })
    console.log(resultarry);
    this.exportAsExcelFile(resultarry, 'General');
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }
  //export data end

  downloadUploadedFile(type: string) {

    const file = this.uploadedFiles[type];

    if (!file) {
      alert('No uploaded file found');
      return;
    }

    const url = window.URL.createObjectURL(file);

    const a = document.createElement('a');
    a.href = url;
    a.download = file.name;

    a.click();

    window.URL.revokeObjectURL(url);
  }

  downloadVaccineTemplate() {
    window.open('assets/templates/vaccine.xlsx');
  }

  downloadDiseaseTemplate() {
    window.open('assets/templates/disease.xlsx');
  }

  downloadSamplesTemplate() {
    window.open('assets/templates/samples.xlsx');
  }

  downloadDiagnosticTemplate() {
    window.open('assets/templates/diagnostic.xlsx');
  }

  downloadDewormingTemplate() {
    window.open('assets/templates/deworming.xlsx');
  }

  downloadDeathTemplate() {
    window.open('assets/templates/death.xlsx');
  }

  addstockmanagement() {
    this.router.navigate([this.addstock]);
  }

}
